"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPointerCursorSelector = void 0;
var re_reselect_1 = __importDefault(require("re-reselect"));
var constants_1 = require("../../../../common/constants");
var get_chart_id_1 = require("../../../../state/selectors/get_chart_id");
var is_brushing_1 = require("./is_brushing");
var picked_shapes_1 = require("./picked_shapes");
exports.getPointerCursorSelector = re_reselect_1.default([picked_shapes_1.getPickedShapes, is_brushing_1.isBrushingSelector], function (pickedShapes, isBrushing) {
    return isBrushing || (Array.isArray(pickedShapes) && pickedShapes.length > 0) ? 'pointer' : constants_1.DEFAULT_CSS_CURSOR;
})(get_chart_id_1.getChartIdSelector);
//# sourceMappingURL=get_cursor_pointer.js.map